/* __next_internal_client_entry_do_not_use__ FormFields auto */ import styled from "styled-components";
/**
 * @trackcomponent
 */ export var FormFields = styled.div.withConfig({
    componentId: "sc-aa1a856b-0"
})([
    'display:grid;grid-template-areas:"',
    '";grid-gap:30px 10px;grid-row-gap:',
    "px;grid-column-gap:",
    "px;"
], function(props) {
    return props.$template.join('"\n"');
}, function(props) {
    return props.$rowGap || 30;
}, function(props) {
    return props.$columnGap || 10;
});
